<template>
  <b-modal size="xl" id="modal-detailHistory" centered scrollable title="Detail Changes" ok-only @show="onModalShow" @hide="closeModal">
    <div class="modal-content mt-2">
      <div class="card" v-if="planChanges?.length > 0">
        <div class="card-header">Budget Plan</div>
        <div class="card-body">
          <vsa-list style="max-width: 100% !important ; border: none">
            <vsa-item v-for="(item, indexItem) in planChanges" :key="indexItem" class="mb-2 border border-warning">
              <vsa-heading>
                <div class="font-weight-bold">
                  <span class="badge bg-warning">Modified</span>
                  {{ item?.category && item.category.slice(0, 1).toUpperCase() + item.category.slice(1) }}
                </div>
              </vsa-heading>
              <vsa-content>
                <div class="row">
                  <div class="col-6"><span class="badge bg-primary mr-2">Old</span>{{ item.old }}</div>
                  <div class="col-6"><span class="badge bg-success mr-2">New</span>{{ item.new }}</div>
                </div>
              </vsa-content>
            </vsa-item>
          </vsa-list>
        </div>
      </div>
      <b-tabs pills card fill>
        <b-tab :title="`OPEX`">
          <div class="card">
            <div class="card-header">Transactions</div>
            <div class="card-body">
              <div class="row" v-if="opexChanges?.opexDiff?.length > 0">
                <vsa-list style="max-width: 100% !important ; border: none">
                  <vsa-item
                    v-for="(transaction, indexTransaction) in opexChanges.opexDiff"
                    :key="indexTransaction"
                    :class="`mb-2 ${
                      transaction.type === 'deleted' || transaction.type === 'transfer_out'
                        ? 'border border-danger'
                        : transaction.type === 'added' || transaction.type === 'transfer_in'
                        ? 'border border-success'
                        : 'border border-warning'
                    }`"
                  >
                    <vsa-heading>
                      <div class="font-weight-bold">
                        <span v-if="transaction.type === 'deleted' || transaction.type === 'transfer_out'" class="badge bg-red">{{
                          transaction.type === 'deleted' ? 'Deleted' : 'Transfered'
                        }}</span>
                        <span v-else-if="transaction.type === 'added' || transaction.type === 'transfer_in'" class="badge bg-success">{{
                          transaction.type === 'added' ? 'Added' : 'Transfered'
                        }}</span>
                        <span v-else class="badge bg-warning">Modified</span>
                        {{
                          transaction.type === 'deleted' || transaction.type === 'transfer_out'
                            ? transaction.old.account_name
                            : transaction.new.account_name
                        }}
                      </div>
                    </vsa-heading>
                    <vsa-content>
                      <!-- id old -->
                      <div class="mb-3 p-2" v-for="(item, indexItem) in transaction?.old?.items">
                        <span>Budget Item : {{ item.item_name }}</span>
                        <div style="overflow: auto">
                          <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                            <thead>
                              <tr>
                                <th style="width: 350px">Budget Task</th>
                                <th style="width: 350px">Description</th>
                                <th style="width: 150px">January</th>
                                <th style="width: 150px">February</th>
                                <th style="width: 150px">March</th>
                                <th style="width: 150px">April</th>
                                <th style="width: 150px">May</th>
                                <th style="width: 150px">June</th>
                                <th style="width: 150px">July</th>
                                <th style="width: 150px">August</th>
                                <th style="width: 150px">September</th>
                                <th style="width: 150px">October</th>
                                <th style="width: 150px">November</th>
                                <th style="width: 150px">December</th>
                                <th style="width: 150px">Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(task, indx) in item?.tasks" :key="indx" class="opex">
                                <td>{{ task.name }}</td>
                                <td>{{ task.description }}</td>
                                <td>Rp. {{ convertNumber(task.jan) }}</td>
                                <td>Rp. {{ convertNumber(task.feb) }}</td>
                                <td>Rp. {{ convertNumber(task.mar) }}</td>
                                <td>Rp. {{ convertNumber(task.apr) }}</td>
                                <td>Rp. {{ convertNumber(task.may) }}</td>
                                <td>Rp. {{ convertNumber(task.jun) }}</td>
                                <td>Rp. {{ convertNumber(task.jul) }}</td>
                                <td>Rp. {{ convertNumber(task.aug) }}</td>
                                <td>Rp. {{ convertNumber(task.sep) }}</td>
                                <td>Rp. {{ convertNumber(task.oct) }}</td>
                                <td>Rp. {{ convertNumber(task.nov) }}</td>
                                <td>Rp. {{ convertNumber(task.dec) }}</td>
                                <td>Rp. {{ convertNumber(task.total) }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <!-- id new -->
                      <div
                        :class="
                          transaction.type === 'deleted' || transaction.type === 'transfer_out'
                            ? 'border border-danger mb-3 p-2'
                            : 'border border-success mb-3 p-2'
                        "
                        v-for="(item, indexItem) in transaction?.new?.items"
                      >
                        <span>Budget Item : {{ item.item_name }}</span>
                        <div style="overflow: auto">
                          <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                            <thead>
                              <tr>
                                <th style="width: 350px">Budget Task</th>
                                <th style="width: 350px">Description</th>
                                <th style="width: 150px">January</th>
                                <th style="width: 150px">February</th>
                                <th style="width: 150px">March</th>
                                <th style="width: 150px">April</th>
                                <th style="width: 150px">May</th>
                                <th style="width: 150px">June</th>
                                <th style="width: 150px">July</th>
                                <th style="width: 150px">August</th>
                                <th style="width: 150px">September</th>
                                <th style="width: 150px">October</th>
                                <th style="width: 150px">November</th>
                                <th style="width: 150px">December</th>
                                <th style="width: 150px">Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(task, indx) in item?.tasks" :key="indx" class="opex">
                                <td>{{ task.name }}</td>
                                <td>{{ task.description }}</td>
                                <td>Rp. {{ convertNumber(task.jan) }}</td>
                                <td>Rp. {{ convertNumber(task.feb) }}</td>
                                <td>Rp. {{ convertNumber(task.mar) }}</td>
                                <td>Rp. {{ convertNumber(task.apr) }}</td>
                                <td>Rp. {{ convertNumber(task.may) }}</td>
                                <td>Rp. {{ convertNumber(task.jun) }}</td>
                                <td>Rp. {{ convertNumber(task.jul) }}</td>
                                <td>Rp. {{ convertNumber(task.aug) }}</td>
                                <td>Rp. {{ convertNumber(task.sep) }}</td>
                                <td>Rp. {{ convertNumber(task.oct) }}</td>
                                <td>Rp. {{ convertNumber(task.nov) }}</td>
                                <td>Rp. {{ convertNumber(task.dec) }}</td>
                                <td>Rp. {{ convertNumber(task.total) }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </vsa-content>
                  </vsa-item>
                </vsa-list>
              </div>
              <div class="row" v-else>
                <div class="col-12 text-center text-info p-3">No Changes</div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">Budget Items</div>
            <div class="card-body">
              <div class="row" v-if="opexChanges?.opexItemDiff?.length > 0">
                <vsa-list style="max-width: 100% !important; border: none">
                  <vsa-item
                    v-for="(item, indexItem) in opexChanges.opexItemDiff"
                    :key="indexItem"
                    :class="`mb-2 ${
                      item.type === 'deleted' || item.type === 'transfer_out'
                        ? 'border border-danger'
                        : item.type === 'added' || item.type === 'transfer_in'
                        ? 'border border-success'
                        : 'border border-warning'
                    }`"
                  >
                    <vsa-heading>
                      <div class="font-weight-bold">
                        <span v-if="item.type === 'deleted' || item.type === 'transfer_out'" class="badge bg-red">{{
                          item.type === 'deleted' ? 'Deleted' : 'Transfered'
                        }}</span>
                        <span v-else-if="item.type === 'added' || item.type === 'transfer_in'" class="badge bg-success">{{
                          item.type === 'added' ? 'Added' : 'Transfered'
                        }}</span>
                        <span v-else class="badge bg-warning">Modified</span>
                        {{
                          item.type === 'deleted' || item.type === 'transfer_out'
                            ? `${item.old?.gl_code} | ${item.old?.item_name}`
                            : `${item.new?.gl_code} | ${item.new?.item_name}`
                        }}
                      </div>
                    </vsa-heading>
                    <vsa-content>
                      <div class="mb-3 p-2">
                        <span>Transaction : {{ item.transaction_name }}</span>
                        <div style="overflow: auto">
                          <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                            <thead>
                              <tr>
                                <th style="width: 350px">Budget Task</th>
                                <th style="width: 350px">Description</th>
                                <th style="width: 150px">January</th>
                                <th style="width: 150px">February</th>
                                <th style="width: 150px">March</th>
                                <th style="width: 150px">April</th>
                                <th style="width: 150px">May</th>
                                <th style="width: 150px">June</th>
                                <th style="width: 150px">July</th>
                                <th style="width: 150px">August</th>
                                <th style="width: 150px">September</th>
                                <th style="width: 150px">October</th>
                                <th style="width: 150px">November</th>
                                <th style="width: 150px">December</th>
                                <th style="width: 150px">Total</th>
                              </tr>
                            </thead>
                            <!-- id old -->
                            <tbody v-if="item.type === 'deleted' || item.type === 'transfer_out'">
                              <tr v-for="(task, indx) in item.old?.tasks" :key="indx" class="opex">
                                <td>{{ task.name }}</td>
                                <td>{{ task.description }}</td>
                                <td>Rp. {{ convertNumber(task.jan) }}</td>
                                <td>Rp. {{ convertNumber(task.feb) }}</td>
                                <td>Rp. {{ convertNumber(task.mar) }}</td>
                                <td>Rp. {{ convertNumber(task.apr) }}</td>
                                <td>Rp. {{ convertNumber(task.may) }}</td>
                                <td>Rp. {{ convertNumber(task.jun) }}</td>
                                <td>Rp. {{ convertNumber(task.jul) }}</td>
                                <td>Rp. {{ convertNumber(task.aug) }}</td>
                                <td>Rp. {{ convertNumber(task.sep) }}</td>
                                <td>Rp. {{ convertNumber(task.oct) }}</td>
                                <td>Rp. {{ convertNumber(task.nov) }}</td>
                                <td>Rp. {{ convertNumber(task.dec) }}</td>
                                <td>Rp. {{ convertNumber(task.total) }}</td>
                              </tr>
                            </tbody>
                            <tbody v-else>
                              <!-- id new -->
                              <tr v-for="(task, indx) in item.new?.tasks" :key="indx" class="opex">
                                <td>{{ task.name }}</td>
                                <td>{{ task.description }}</td>
                                <td>Rp. {{ convertNumber(task.jan) }}</td>
                                <td>Rp. {{ convertNumber(task.feb) }}</td>
                                <td>Rp. {{ convertNumber(task.mar) }}</td>
                                <td>Rp. {{ convertNumber(task.apr) }}</td>
                                <td>Rp. {{ convertNumber(task.may) }}</td>
                                <td>Rp. {{ convertNumber(task.jun) }}</td>
                                <td>Rp. {{ convertNumber(task.jul) }}</td>
                                <td>Rp. {{ convertNumber(task.aug) }}</td>
                                <td>Rp. {{ convertNumber(task.sep) }}</td>
                                <td>Rp. {{ convertNumber(task.oct) }}</td>
                                <td>Rp. {{ convertNumber(task.nov) }}</td>
                                <td>Rp. {{ convertNumber(task.dec) }}</td>
                                <td>Rp. {{ convertNumber(task.total) }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </vsa-content>
                  </vsa-item>
                </vsa-list>
              </div>
              <div v-else class="row">
                <div class="col-12 text-center text-info p-3">No Changes</div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">Budget Task</div>
            <div class="card-body">
              <div class="row" v-if="opexChanges?.opexTaskDiff?.length > 0">
                <vsa-list style="max-width: 100% !important; border: none">
                  <vsa-item
                    v-for="(task, indexTask) in opexChanges.opexTaskDiff"
                    :key="indexTask"
                    :class="`mb-2 ${
                      task.type === 'deleted' || task.type === 'transfer_out'
                        ? 'border border-danger'
                        : task.type === 'added' || task.type === 'transfer_in'
                        ? 'border border-success'
                        : 'border border-warning'
                    }`"
                  >
                    <vsa-heading>
                      <div class="font-weight-bold">
                        <span v-if="task.type === 'deleted' || task.type === 'transfer_out'" class="badge bg-red">{{
                          task.type === 'deleted' ? 'Deleted' : 'Transfered'
                        }}</span>
                        <span v-else-if="task.type === 'added' || task.type === 'transfer_in'" class="badge bg-success">{{
                          task.type === 'added' ? 'Added' : 'Transfered'
                        }}</span>
                        <span v-else class="badge bg-warning">Modified</span>
                        {{ task.type === 'deleted' || task.type === 'transfer_out' ? `${task.old?.name}` : `${task.new?.name}` }}
                      </div>
                    </vsa-heading>
                    <vsa-content>
                      <div class="mb-3 p-2">
                        <span>Transaction : {{ task.transaction_name }}</span
                        ><br />
                        <span>Item : {{ task.item_name }}</span>
                        <div style="overflow: auto">
                          <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                            <thead>
                              <tr>
                                <th style="width: 350px">Budget Task</th>
                                <th style="width: 350px">Description</th>
                                <th style="width: 150px">January</th>
                                <th style="width: 150px">February</th>
                                <th style="width: 150px">March</th>
                                <th style="width: 150px">April</th>
                                <th style="width: 150px">May</th>
                                <th style="width: 150px">June</th>
                                <th style="width: 150px">July</th>
                                <th style="width: 150px">August</th>
                                <th style="width: 150px">September</th>
                                <th style="width: 150px">October</th>
                                <th style="width: 150px">November</th>
                                <th style="width: 150px">December</th>
                                <th style="width: 150px">Total</th>
                              </tr>
                            </thead>
                            <!-- id old -->
                            <tbody>
                              <tr class="opex" v-if="task.type === 'deleted' || task.type === 'transfer_out'">
                                <td><span class="badge bg-red mr-2">Old</span>{{ task.old?.name }}</td>
                                <td>{{ task.old?.description }}</td>
                                <td>Rp. {{ convertNumber(task.old?.jan) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.feb) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.mar) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.apr) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.may) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.jun) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.jul) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.aug) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.sep) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.oct) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.nov) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.dec) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.total) }}</td>
                              </tr>
                              <tr class="opex" v-if="task.type === 'added' || task.type === 'transfer_in'">
                                <td><span class="badge bg-green mr-2">New</span>{{ task.new?.name }}</td>
                                <td>{{ task.new?.description }}</td>
                                <td>Rp. {{ convertNumber(task.new?.jan) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.feb) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.mar) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.apr) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.may) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.jun) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.jul) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.aug) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.sep) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.oct) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.nov) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.dec) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.total) }}</td>
                              </tr>
                              <tr class="opex" v-if="task.type === 'modified'">
                                <td><span class="badge bg-red mr-2">Old</span>{{ task.old?.name }}</td>
                                <td>{{ task.old?.description }}</td>
                                <td>Rp. {{ convertNumber(task.old?.jan) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.feb) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.mar) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.apr) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.may) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.jun) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.jul) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.aug) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.sep) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.oct) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.nov) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.dec) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.total) }}</td>
                              </tr>
                              <tr class="opex" v-if="task.type === 'modified'">
                                <td :class="`${task.new?.name !== task.old?.name ? 'td-green' : ''}`">
                                  <span class="badge bg-green mr-2">New</span>{{ task.new?.name }}
                                </td>
                                <td :class="`${task.new?.description !== task.old?.description ? 'td-green' : ''}`">
                                  {{ task.new?.description }}
                                </td>
                                <td :class="`${task.new?.jan !== task.old?.jan ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.jan) }}</td>
                                <td :class="`${task.new?.feb !== task.old?.feb ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.feb) }}</td>
                                <td :class="`${task.new?.mar !== task.old?.mar ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.mar) }}</td>
                                <td :class="`${task.new?.apr !== task.old?.apr ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.apr) }}</td>
                                <td :class="`${task.new?.may !== task.old?.may ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.may) }}</td>
                                <td :class="`${task.new?.jun !== task.old?.jun ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.jun) }}</td>
                                <td :class="`${task.new?.jul !== task.old?.jul ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.jul) }}</td>
                                <td :class="`${task.new?.aug !== task.old?.aug ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.aug) }}</td>
                                <td :class="`${task.new?.sep !== task.old?.sep ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.sep) }}</td>
                                <td :class="`${task.new?.oct !== task.old?.oct ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.oct) }}</td>
                                <td :class="`${task.new?.nov !== task.old?.nov ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.nov) }}</td>
                                <td :class="`${task.new?.dec !== task.old?.dec ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.dec) }}</td>
                                <td :class="`${task.new?.total !== task.old?.total ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.total) }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </vsa-content>
                  </vsa-item>
                </vsa-list>
              </div>
              <div v-else class="row">
                <div class="col-12 text-center text-info p-3">No Changes</div>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab :title="`CAPEX`">
          <div class="card">
            <div class="card-header">Budget Items</div>
            <div class="card-body">
              <div class="row" v-if="capexChanges?.capexDiff?.length > 0">
                <vsa-list style="max-width: 100% !important; border: none">
                  <vsa-item
                    v-for="(item, indexItem) in capexChanges.capexDiff"
                    :key="indexItem"
                    :class="`mb-2 ${
                      item.type === 'deleted' ? 'border border-danger' : item.type === 'modified' ? 'border border-warning' : 'border border-success'
                    }`"
                  >
                    <vsa-heading>
                      <div class="font-weight-bold">
                        <span v-if="item.type === 'deleted'" class="badge bg-red">Deleted</span>
                        <span v-else class="badge bg-green">Added</span>
                        {{
                          item.type === 'deleted'
                            ? `${item.old?.fund || ''} - ${item.old?.account_name}`
                            : `${item.new?.fund || ''} - ${item.new?.account_name}`
                        }}
                      </div>
                    </vsa-heading>
                    <vsa-content>
                      <div class="mb-3 p-2">
                        <div style="overflow: auto">
                          <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                            <thead>
                              <tr>
                                <th style="width: 350px">Budget Task</th>
                                <th style="width: 350px">Description</th>
                                <th style="width: 150px">January</th>
                                <th style="width: 150px">February</th>
                                <th style="width: 150px">March</th>
                                <th style="width: 150px">April</th>
                                <th style="width: 150px">May</th>
                                <th style="width: 150px">June</th>
                                <th style="width: 150px">July</th>
                                <th style="width: 150px">August</th>
                                <th style="width: 150px">September</th>
                                <th style="width: 150px">October</th>
                                <th style="width: 150px">November</th>
                                <th style="width: 150px">December</th>
                                <th style="width: 150px">Total</th>
                              </tr>
                            </thead>
                            <!-- id old -->
                            <tbody v-if="item.type === 'deleted'">
                              <tr v-for="(task, indx) in item.old?.tasks" :key="indx" class="opex">
                                <td>{{ task.name }}</td>
                                <td>{{ task.description }}</td>
                                <td>Rp. {{ convertNumber(task.jan) }}</td>
                                <td>Rp. {{ convertNumber(task.feb) }}</td>
                                <td>Rp. {{ convertNumber(task.mar) }}</td>
                                <td>Rp. {{ convertNumber(task.apr) }}</td>
                                <td>Rp. {{ convertNumber(task.may) }}</td>
                                <td>Rp. {{ convertNumber(task.jun) }}</td>
                                <td>Rp. {{ convertNumber(task.jul) }}</td>
                                <td>Rp. {{ convertNumber(task.aug) }}</td>
                                <td>Rp. {{ convertNumber(task.sep) }}</td>
                                <td>Rp. {{ convertNumber(task.oct) }}</td>
                                <td>Rp. {{ convertNumber(task.nov) }}</td>
                                <td>Rp. {{ convertNumber(task.dec) }}</td>
                                <td>Rp. {{ convertNumber(task.total) }}</td>
                              </tr>
                            </tbody>
                            <tbody v-else>
                              <!-- id new -->
                              <tr v-for="(task, indx) in item.new?.tasks" :key="indx" class="opex">
                                <td>{{ task.name }}</td>
                                <td>{{ task.description }}</td>
                                <td>Rp. {{ convertNumber(task.jan) }}</td>
                                <td>Rp. {{ convertNumber(task.feb) }}</td>
                                <td>Rp. {{ convertNumber(task.mar) }}</td>
                                <td>Rp. {{ convertNumber(task.apr) }}</td>
                                <td>Rp. {{ convertNumber(task.may) }}</td>
                                <td>Rp. {{ convertNumber(task.jun) }}</td>
                                <td>Rp. {{ convertNumber(task.jul) }}</td>
                                <td>Rp. {{ convertNumber(task.aug) }}</td>
                                <td>Rp. {{ convertNumber(task.sep) }}</td>
                                <td>Rp. {{ convertNumber(task.oct) }}</td>
                                <td>Rp. {{ convertNumber(task.nov) }}</td>
                                <td>Rp. {{ convertNumber(task.dec) }}</td>
                                <td>Rp. {{ convertNumber(task.total) }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </vsa-content>
                  </vsa-item>
                </vsa-list>
              </div>
              <div v-else class="row">
                <div class="col-12 text-center text-info p-3">No Changes</div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">Budget Task</div>
            <div class="card-body">
              <div class="row" v-if="capexChanges?.capexTaskDiff?.length > 0">
                <vsa-list style="max-width: 100% !important; border: none">
                  <vsa-item
                    v-for="(task, indexTask) in capexChanges.capexTaskDiff"
                    :key="indexTask"
                    :class="`mb-2 ${
                      task.type === 'deleted' ? 'border border-danger' : task.type === 'modified' ? 'border border-warning' : 'border border-success'
                    }`"
                  >
                    <vsa-heading>
                      <div class="font-weight-bold">
                        <span :class="`badge ${task.type === 'deleted' ? 'bg-red' : task.type === 'modified' ? 'bg-yellow' : 'bg-green'}`">{{
                          task.type === 'deleted' ? 'Deleted' : task.type === 'modified' ? 'Modified' : 'Added'
                        }}</span>
                        {{ task.type === 'deleted' ? `${task.old?.name}` : `${task.new?.name}` }}
                      </div>
                    </vsa-heading>
                    <vsa-content>
                      <div class="mb-3 p-2">
                        <span>Item : {{ task.item_name }}</span>
                        <div style="overflow: auto">
                          <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                            <thead>
                              <tr>
                                <th style="width: 350px">Budget Task</th>
                                <th style="width: 350px">Description</th>
                                <th style="width: 150px">January</th>
                                <th style="width: 150px">February</th>
                                <th style="width: 150px">March</th>
                                <th style="width: 150px">April</th>
                                <th style="width: 150px">May</th>
                                <th style="width: 150px">June</th>
                                <th style="width: 150px">July</th>
                                <th style="width: 150px">August</th>
                                <th style="width: 150px">September</th>
                                <th style="width: 150px">October</th>
                                <th style="width: 150px">November</th>
                                <th style="width: 150px">December</th>
                                <th style="width: 150px">Total</th>
                              </tr>
                            </thead>
                            <!-- id old -->
                            <tbody>
                              <tr class="opex" v-if="task.type === 'deleted'">
                                <td><span class="badge bg-red mr-2">Old</span>{{ task.old?.name }}</td>
                                <td>{{ task.old?.description }}</td>
                                <td>Rp. {{ convertNumber(task.old?.jan) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.feb) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.mar) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.apr) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.may) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.jun) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.jul) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.aug) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.sep) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.oct) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.nov) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.dec) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.total) }}</td>
                              </tr>
                              <tr class="opex" v-if="task.type === 'added'">
                                <td><span class="badge bg-green mr-2">New</span>{{ task.new?.name }}</td>
                                <td>{{ task.new?.description }}</td>
                                <td>Rp. {{ convertNumber(task.new?.jan) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.feb) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.mar) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.apr) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.may) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.jun) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.jul) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.aug) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.sep) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.oct) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.nov) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.dec) }}</td>
                                <td>Rp. {{ convertNumber(task.new?.total) }}</td>
                              </tr>
                              <tr class="opex" v-if="task.type === 'modified'">
                                <td><span class="badge bg-red mr-2">Old</span>{{ task.old?.name }}</td>
                                <td>{{ task.old?.description }}</td>
                                <td>Rp. {{ convertNumber(task.old?.jan) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.feb) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.mar) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.apr) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.may) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.jun) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.jul) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.aug) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.sep) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.oct) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.nov) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.dec) }}</td>
                                <td>Rp. {{ convertNumber(task.old?.total) }}</td>
                              </tr>
                              <tr class="opex" v-if="task.type === 'modified'">
                                <td :class="`${task.new?.name !== task.old?.name ? 'td-green' : ''}`">
                                  <span class="badge bg-green mr-2">New</span>{{ task.new?.name }}
                                </td>
                                <td :class="`${task.new?.description !== task.old?.description ? 'td-green' : ''}`">
                                  {{ task.new?.description }}
                                </td>
                                <td :class="`${task.new?.jan !== task.old?.jan ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.jan) }}</td>
                                <td :class="`${task.new?.feb !== task.old?.feb ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.feb) }}</td>
                                <td :class="`${task.new?.mar !== task.old?.mar ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.mar) }}</td>
                                <td :class="`${task.new?.apr !== task.old?.apr ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.apr) }}</td>
                                <td :class="`${task.new?.may !== task.old?.may ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.may) }}</td>
                                <td :class="`${task.new?.jun !== task.old?.jun ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.jun) }}</td>
                                <td :class="`${task.new?.jul !== task.old?.jul ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.jul) }}</td>
                                <td :class="`${task.new?.aug !== task.old?.aug ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.aug) }}</td>
                                <td :class="`${task.new?.sep !== task.old?.sep ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.sep) }}</td>
                                <td :class="`${task.new?.oct !== task.old?.oct ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.oct) }}</td>
                                <td :class="`${task.new?.nov !== task.old?.nov ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.nov) }}</td>
                                <td :class="`${task.new?.dec !== task.old?.dec ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.dec) }}</td>
                                <td :class="`${task.new?.total !== task.old?.total ? 'td-green' : ''}`">Rp. {{ convertNumber(task.new?.total) }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </vsa-content>
                  </vsa-item>
                </vsa-list>
              </div>
              <div v-else class="row">
                <div class="col-12 text-center text-info p-3">No Changes</div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
      <div class="card ml-4 mr-4 mt-n4" v-if="type == 'Pengajuan Khusus'">
        <div class="card-header">Pengajuan Khusus</div>
        <div class="card-body">
          <div class="row row-cols-1 row-cols-md-3 gx-3 gy-5 mt-2 mb-2">
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-home"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Action</h4>
                  <small class="text-body-secondary"><span> Penambahan Budget IM Pengajuan Khusus</span> </small>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-home"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">IM Name</h4>
                  <small class="text-body-secondary"
                    ><span> {{ imRelocate?.name }}</span>
                  </small>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-home"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">IM Number</h4>
                  <small class="text-body-secondary"
                    ><span> {{ imRelocate?.im_number }}</span>
                  </small>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-home"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">GL</h4>
                  <small class="text-body-secondary">
                    <span>
                      {{ `${imRelocate?.im_budget?.taskDetail?.gl_code} | ${imRelocate?.im_budget?.taskDetail?.account_name}` }}
                    </span>
                  </small>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-home"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Budget Task</h4>
                  <small class="text-body-secondary"
                    ><span> {{ imRelocate?.im_budget?.taskDetail?.name }}</span>
                  </small>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-calendar"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Budget Task Month</h4>
                  <small class="text-body-secondary"
                    ><span> {{ getMonthName(imRelocate?.im_budget?.month) }}</span>
                  </small>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="avatar avatar-sm">
                    <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                      <i class="fe fe-home"></i>
                    </div>
                  </div>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1 font-weight-bold">Relocation Value</h4>
                  <small class="text-body-secondary"
                    ><span>Rp. {{ convertNumber(imRelocate?.im_budget?.relocate_value) }}</span>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { VsaList, VsaItem, VsaHeading, VsaContent, VsaIcon } from 'vue-simple-accordion';

export default {
  name: 'ModalDetailHistory',
  props: { changes: Object, type: String },
  components: {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
    VsaIcon,
  },
  computed: {
    imRelocate() {
      if (this.type == 'Pengajuan Khusus') {
        return this.changes.imRelocate;
      }
      return null;
    },
  },
  data() {
    return {
      opexChanges: {
        opexDiff: [],
        opexItemDiff: [],
        opexTaskDiff: [],
      },
      capexChanges: {
        capexDiff: [],
        capexTaskDiff: [],
      },
      planChanges: [],
    };
  },
  methods: {
    onModalShow() {
      this.opexChanges = {
        opexDiff: this.changes?.opexDiff || [],
        opexItemDiff: this.changes?.opexItemDiff || [],
        opexTaskDiff: this.changes?.opexTaskDiff || [],
      };
      this.capexChanges = {
        capexDiff: this.changes?.capexDiff || [],
        capexTaskDiff: this.changes?.capexTaskDiff || [],
      };
      this.planChanges = this.changes.planDiff || [];
    },

    resetPayload() {
      this.opexChanges = {};
      this.capexChanges = {};
    },

    closeModal(evt) {
      this.resetPayload();
      this.$emit('hide-modal');
    },

    convertNumber(dat) {
      return parseInt(dat)
        .toString()
        .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
    },
    getMonthName(month) {
      switch (month) {
        case 'jan':
          return 'January';
        case 'feb':
          return 'February';
        case 'mar':
          return 'March';
        case 'apr':
          return 'April';
        case 'may':
          return 'May';
        case 'jun':
          return 'June';
        case 'jul':
          return 'July';
        case 'aug':
          return 'August';
        case 'sep':
          return 'September';
        case 'oct':
          return 'October';
        case 'nov':
          return 'November';
        case 'dec':
          return 'December';
        default:
          return '-';
      }
    },
  },
};
</script>
<style>
.vsa-item__heading {
  width: 100%;
  height: 100%;
}
.vsa-item__heading,
.vsa-item__trigger {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.vsa-item__trigger {
  margin: 0;
  padding: 0;
  color: inherit;
  font-family: inherit;
  font-size: 16px;
  line-height: 1.15;
  border-width: 0;
  background-color: transparent;
  background-image: none;
  overflow: visible;
  text-transform: none;
  flex: 1 1 auto;
  color: var(--vsa-text-color);
  transition: all 0.2s linear;
  padding: var(--vsa-heading-padding);
}
.vsa-item__trigger[role='button'] {
  cursor: pointer;
}
.vsa-item__trigger[type='button'],
.vsa-item__trigger[type='reset'],
.vsa-item__trigger[type='submit'] {
  -webkit-appearance: button;
}
.vsa-item__trigger:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}
.vsa-item__trigger::-moz-focus-inner,
.vsa-item__trigger[type='button']::-moz-focus-inner,
.vsa-item__trigger[type='reset']::-moz-focus-inner,
.vsa-item__trigger[type='submit']::-moz-focus-inner {
  border-style: none;
  padding: 0;
}
.vsa-item__trigger:-moz-focusring,
.vsa-item__trigger[type='button']:-moz-focusring,
.vsa-item__trigger[type='reset']:-moz-focusring,
.vsa-item__trigger[type='submit']:-moz-focusring {
  outline: 1px dotted ButtonText;
}
.vsa-item__trigger:focus,
.vsa-item__trigger:hover {
  outline: none;
  background-color: #bb0d29;
  color: #fff5f7;
}

.vsa-item__trigger__icon--is-default:before {
  left: 0;
  transform: rotate(45deg) translate3d(8px, 22px, 0);
  transform-origin: 100%;
}
.vsa-item__trigger__icon--is-default:after {
  transform: rotate(-45deg) translate3d(-8px, 22px, 0);
  right: 0;
  transform-origin: 0;
}
.vsa-item__trigger[aria-expanded='true'] .vsa-item__trigger__icon--is-default:before {
  transform: rotate(45deg) translate3d(14px, 14px, 0);
}
.vsa-item__trigger[aria-expanded='true'] .vsa-item__trigger__icon--is-default:after {
  transform: rotate(-45deg) translate3d(-14px, 14px, 0);
}
.vsa-item__trigger__icon {
  display: block;
  margin-left: auto;
  position: relative;
  transition: all 0.2s ease-in-out;
}
.vsa-item__trigger:focus .vsa-item__trigger__icon--is-default:after,
.vsa-item__trigger:focus .vsa-item__trigger__icon--is-default:before,
.vsa-item__trigger:hover .vsa-item__trigger__icon--is-default:after,
.vsa-item__trigger:hover .vsa-item__trigger__icon--is-default:before {
  background-color: var(--vsa-bg-color);
}
.vsa-item__trigger__content {
  font-weight: 700;
  font-size: 14px !important;
}
.vsa-item__content {
  margin: 0;
  padding: 20px 20px;
}
.vsa-item--is-active .vsa-item__heading,
.vsa-item:not(:last-of-type) {
  border-bottom: var(--vsa-border);
}
.vsa-collapse-enter-active,
.vsa-collapse-leave-active {
  transition-property: opacity, height, padding-top, padding-bottom;
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
}
.vsa-collapse-enter,
.vsa-collapse-leave-active {
  opacity: 0;
  height: 0;
  padding-top: 0;
  padding-bottom: 0;
  overflow: hidden;
}
.vsa-list {
  --vsa-max-width: 720px;
  --vsa-min-width: 300px;
  --vsa-heading-padding: 10px 10px;
  --vsa-text-color: #373737;
  --vsa-highlight-color: transparent;
  --vsa-bg-color: #fff;
  --vsa-border-color: rgba(0, 0, 0, 0.2);
  --vsa-border-width: 1px;
  --vsa-border-style: solid;
  --vsa-border: var(--vsa-border-width) var(--vsa-border-style) var(--vsa-border-color);
  --vsa-content-padding: 1rem 1rem;
  --vsa-default-icon-size: 1;
  display: block;
  max-width: var(--vsa-max-width);
  min-width: var(--vsa-min-width);
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  border: var(--vsa-border);
  color: var(--vsa-text-color);
  background-color: var(--vsa-bg-color);
}
.vsa-list [hidden] {
  display: none;
}
.historical-log {
  padding: 20px;
}
.historical-log ul {
  list-style-type: none;
  padding: 0;
}
.historical-log li {
  margin-bottom: 15px;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
}
.badge-lg {
  padding: 0.5rem 0.8rem !important;
  margin-bottom: 0px !important;
}
.badge.bg-green {
  background-color: #2ecc71;
}

.badge.bg-red {
  background-color: #ff0000;
}

.badge.bg-pink {
  background-color: #fd9596;
}

.badge.bg-dark {
  background-color: #333333;
}

.badge.bg-yellow {
  background-color: #f1c40f;
}

.badge.bg-orange {
  background-color: #e67e22;
}

.badge.bg-gray {
  background-color: #999999;
}

.td-green {
  background-color: #b5f9b4 !important;
}

button .vsa-item__trigger {
  text-align: center !important;
}
</style>
